import React from "react";
import { useNavigate } from "react-router-dom";
import {
  BrainCircuit,
  TrendingUp,
  BarChart4,
  Sparkles,
  ArrowRight,
} from "lucide-react";

const cards = [
  {
    title: "Stocks Prediction",
    desc: "AI Buy/Sell predictions for US Stocks",
    color: "from-blue-600 to-cyan-500",
    icon: TrendingUp,
    route: "/dashboard/ai/stocks",
  },
  {
    title: "Options Prediction",
    desc: "AI Call & Put opportunity finder",
    color: "from-violet-600 to-fuchsia-500",
    icon: BarChart4,
    route: "/dashboard/ai/options",
  },
  {
    title: "AI Analysis",
    desc: "Complete technical + AI analysis",
    color: "from-green-600 to-emerald-500",
    icon: BrainCircuit,
    route: "/dashboard/ai/analysis",
  },
  {
    title: "Future Prediction",
    desc: "7/30/90 day AI forecast",
    color: "from-orange-500 to-red-500",
    icon: Sparkles,
    route: "/dashboard/ai/future",
  },
];

export default function AITrading() {
  const navigate = useNavigate();

  return (
    <div className="space-y-8">

      <div className="card-tactical rounded-2xl p-8">

        <div className="flex items-center gap-4 mb-4">

          <div className="w-14 h-14 rounded-xl bg-blue-600 flex items-center justify-center">
            <BrainCircuit className="text-white" size={28} />
          </div>

          <div>

            <h1 className="text-3xl font-bold">
              AI Trading Center
            </h1>

            <p className="text-white/60 mt-1">
              Artificial Intelligence powered US Stock Market tools.
            </p>

          </div>

        </div>

      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-2 gap-6">

        {cards.map((card) => (
          <div
            key={card.title}
            onClick={() => navigate(card.route)}
            className="cursor-pointer rounded-2xl overflow-hidden border border-white/10 hover:border-blue-500 transition group"
          >

            <div className={`bg-gradient-to-r ${card.color} p-6`}>

              <card.icon size={40} />

            </div>

            <div className="p-6">

              <h2 className="text-2xl font-bold mb-2">
                {card.title}
              </h2>

              <p className="text-white/60">
                {card.desc}
              </p>

              <div className="mt-6 flex items-center gap-2 text-blue-400 group-hover:translate-x-2 transition">

                Open

                <ArrowRight size={18} />

              </div>

            </div>

          </div>
        ))}

      </div>

    </div>
  );
}
